export default __webpack_public_path__ + "static/media/download_2.ee5af8e9.svg";